import { render } from "./KuponTelur.vue?vue&type=template&id=68f66596"
import script from "./KuponTelur.vue?vue&type=script&lang=js"
export * from "./KuponTelur.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__